import HttpClient from './HttpClient'

export async function fetchRoleSystems() {
  const { data } = await HttpClient().get('/api/v1/role-systems')
  return Array.isArray(data?.data) ? data.data : []
}

export async function fetchRoleSystem(slug) {
  const { data } = await HttpClient().get(`/api/v1/role-systems/${encodeURIComponent(slug)}`)
  return data?.data ?? null
}
